import {
  ArrowBackIosRoundedIcon,
  ArrowForwardIosRoundedIcon,
  Flex,
  IconButton,
  Text,
} from '@shared/components';

import { ROW_PER_PAGE } from '../../constants';

export interface QuestionPaginationProps {
  currentQuestion: number;
  currentPage: number;
  totalQuestions: number;
  onChange: (value: number) => void;
}

export default function QuestionPagination(props: Readonly<QuestionPaginationProps>) {
  const { currentQuestion, currentPage, totalQuestions, onChange } = props;

  const count = Math.ceil(totalQuestions / ROW_PER_PAGE);
  const page = Math.floor(currentQuestion / ROW_PER_PAGE) + 1;
  const maximumInPage = ROW_PER_PAGE * page > totalQuestions ? totalQuestions : ROW_PER_PAGE * page;

  return (
    <Flex sx={{ alignItems: 'center', justifyContent: 'space-between' }}>
      <IconButton
        size='small'
        aria-label='previous page'
        onClick={() => onChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        <ArrowBackIosRoundedIcon />
      </IconButton>
      <Text variant='body2'>
        {currentQuestion}-{maximumInPage} of {totalQuestions}
      </Text>
      <IconButton
        aria-label='next page'
        onClick={() => onChange(currentPage + 1)}
        disabled={currentPage === count}
      >
        <ArrowForwardIosRoundedIcon />
      </IconButton>
    </Flex>
  );
}
